import { Code, Divider, Select, Stack, Textarea, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import P4Regular from 'components/typography/P4Regular';
import { Fragment, useMemo } from 'react';

export interface IPredefinedListFormat {
  structure: string;
  lineTemplate?: string;
  separator?: string;
  prefix?: string;
  suffix?: string;
}

/**
 * Configurator for placeholders of type 'predefinedList'
 */
export default function PredefinedListConfigurator({ form }: { form: UseFormReturnType<IPredefinedListFormat> }) {
  const options = useMemo(
    () => [
      { value: 'unordered-list', label: 'Nečíslovaný zoznam' },
      { value: 'custom', label: 'Vlastný formát (HTML)' },
    ],
    []
  );

  return (
    <Stack spacing={12}>
      <Select
        label="Štruktúra výpisu"
        size="sm"
        data={options}
        defaultValue="unordered-list"
        required
        {...form.getInputProps('structure')}
      />
      {form.values.structure === 'custom' && (
        <Fragment>
          <Divider mt={4} color="gray.0" />
          <Stack spacing={4}>
            <Textarea
              label="Šablóna riadku"
              size="sm"
              required
              {...form.getInputProps('lineTemplate')}
              minRows={1}
              autosize
            />
            <P4Regular c="gray.6">
              Použite zástupné znaky <Code c="gray.6">{'{name}'}</Code>, <Code c="gray.6">{'{description}'}</Code>,{' '}
              <Code c="gray.6">{'{moreInfo}'}</Code>
            </P4Regular>
          </Stack>
          <TextInput label="Oddeľovač" size="sm" {...form.getInputProps('separator')} />
          <TextInput label="Prefix" size="sm" {...form.getInputProps('prefix')} />
          <TextInput label="Suffix" size="sm" {...form.getInputProps('suffix')} />
        </Fragment>
      )}
    </Stack>
  );
}
